import { NotaCreditoDetalle } from "./nota-credito-detalle";
import { Caja } from "./caja";
import { Venta } from "./venta";
import { Compra } from "./compra";
import { AsientoContable } from "./asiento-contable";

export class NotaCredito{
    public constructor(
        public id: String = "",
        public tipo: String = "",
        public motivo: String = "",
        public correo: String = "",
        public tipo_comprobante_id: String = "",
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public numero_documento: String = "",
        public is_secuencial_manual: boolean = false,
        public fecha_emision: any = "",
        public numero_autorizacion: String = "",
        public subtotal_iva0: number = 0,
        public subtotal_iva12: number = 0,
        public subtotal: number = 0,
        public iva: number = 0,
        public total: number = 0,
        public valor_utilizado: number = 0,
        public valor_a_utilizar: number = 0,
        public observacion: String = "",
        public json_string: any = {},
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public documento_id: String = "",
        public caja_id: String = "",
        public status: String = "",
        public usuario_id: String = "",
        public selected: boolean = false,
        
        public estado_cobro: String = "P",
        public detalle: Array<NotaCreditoDetalle> = [],
        public tipocomprobante: any = {},
        public estadobitacora: any = {},
        public caja: Caja = new Caja(),
        public venta: Venta = new Venta(),
        public compra: Compra = new Compra(),
        public asientosContables: Array<AsientoContable> = [],
    ){
        //
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/nota-credito.ts